// @owners { team: patients }
import React from 'react';
import { useFeaturedOtcsForShipment } from '../hooks/useFeaturedOtcsForShipment';

type Props = {
  /**
   * Rendered above the children, and only when there is something to separate. Each surface passes
   * its own separator because the spacing and the horizontal bleed differ between cards.
   */
  readonly separator: React.ReactNode;
  readonly children: React.ReactNode;
};

/**
 * Gates the essentials upsell and its separator together.
 *
 * The carousel renders nothing when there are no featured OTCs for the shipment, so rendering the
 * separator alongside it used to leave an orphaned divider at the bottom of the card.
 *
 * Nothing renders while the query is still in flight either. The carousel has no loading state of
 * its own, so a separator shown during that window would be framing empty space — a short-lived
 * version of the very bug this component exists to prevent.
 */
export const EssentialsCarouselSection = ({ separator, children }: Props) => {
  const { hasProducts } = useFeaturedOtcsForShipment();

  if (!hasProducts) {
    return null;
  }

  return (
    <>
      {separator}
      {children}
    </>
  );
};
